<template>
  <div
    :class="[computedSize ? 'rt-loading-' + computedSize : '']"
    class="rt-loading"
  >
    <div
      v-show="visible"
      :class="[showMask ? 'rt-loading-mask' : 'rt-loading-hide-mask']"
    ></div>
    <transition
      name="rt-fade-ease-in-out"
      @after-leave="handleAfterLeave"
    >
      <div
        v-show="visible"
        class="rt-loading-spinner"
      >
        <span
          v-if="computedType === 1 || !computedType"
          class="rt-loading-dot"
        >
          <i></i>
          <i></i>
          <i></i>
        </span>
        <rt-icon
          v-else
          class="rt-loading-circle"
          name="rt-base-loading-filled"
          :size="computedIconSize"
        />
        <p
          v-if="textColor"
          :class="[textColor ? 'rt-loading-text-' + textColor : '']"
          class="rt-loading-text"
        >
          {{ text }}
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
import xpcConfig from '../../../config';
export default {
  data () {
    return {
      text: null,
      spinner: null,
      background: null,
      visible: false,
      type: {
        type: Number,
        default: 1
      },
      size: '',
      textColor: '',
      showMask: false
    };
  },
  computed: {
    computedType () {
      return this.type || xpcConfig.get('loading.type');
    },
    computedSize () {
      return this.size || xpcConfig.get('loading.size');
    },
    computedIconSize () {
      let size = this.computedSize;
      let iconSize = '';
      switch (size) {
        case 'small':
          iconSize = 20;
          break;
        case 'medium':
          iconSize = 40;
          break;
        case 'large':
          iconSize = 56;
          break;
        default:
          iconSize = 56;
      }
      return iconSize;
    }
  },
  methods: {
    handleAfterLeave () {
      this.$emit('after-leave');
    },
    setText (text) {
      this.text = text;
    },
    setSize (size) {
      this.size = size;
    },
    setTextColor (textColor) {
      this.textColor = textColor;
    },
    setType (type) {
      this.type = type;
    },
    setHiddenMask (hiddenMask) {
      this.hiddenMask = hiddenMask;
    }
  }
};
</script>



// WEBPACK FOOTER //
// loading.vue?20bf825e